import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { withStyles, Grid, Hidden } from '@material-ui/core'
import styles from './styles'
// import FormContent from './FormContent'
// import Preview from './Preview'
// import CodeEditor from 'components/TemplateForm/CodeEditor'
import { last } from 'lodash'
import MobileForm from './MobileForm'
import Variables from 'components/TemplateForm/Variables'
import General from './General'
import EmailForm from './FormContent/Email/Form'
import RSC from 'react-scrollbars-custom'
import EditorDialog from './EditorDialog'
import PreviewAndFormContent from './PreviewAndFormContent'
import classnames from 'classnames'
import MultiExpansionPanels from 'components/MultiExpansionPanels'
import Editor from 'components/TemplateForm/Editor'

const SplitForm = ({
	classes,
	codeEditorDisplayed,
	emailCardSelected,
	selectedActionPrediction,
	modal,
	sectionSelectedBool,
}) => {
	return (
    <main style={{ position: 'relative', height: '100%' }}>
      <Grid
        style={{ width: '100%' }}
        className={classes.splitFormGrid}
        container
        spacing={24}
      >
        <Hidden smDown>
          <Grid
            className={classnames(classes.splitGrid, classes.left)}
            style={{
              margin: 0,
              overflowY: 'auto',
              // maxHeight: '1200px',
            }}
            item
            xl={8}
            lg={8}
            md={8}
          >
            <PreviewAndFormContent modal={modal} />
          </Grid>
        </Hidden>
        <Hidden mdUp>
          <Grid
            className={classnames(classes.splitGrid, classes.left)}
            style={{
              margin: 0,
              overflowY: 'auto',
              // maxHeight: '1200px',
              padding: 0,
              height: '100%',
            }}
            item
            xl={8}
            lg={8}
            md={8}
          >
            <PreviewAndFormContent modal={modal} />
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid
            className={classes.right}
            item
            xl={4}
            lg={4}
            md={4}
            style={{
              height: '100%',
              margin: 0,
              paddingRight: 10,
            }}
          >
            <RSC style={{ height: 'calc(100% + 15px)' }} noScrollX>
              <Grid
                style={{
                  width: '100%',
                  margin: '0 10px 0 0',
                  padding: '0px 10px 10px 10px',
                }}
                container
                spacing={24}
              >
                <Hidden mdDown>
                  {sectionSelectedBool ? (
                    <Grid item xs={12} style={{ padding: 0, marginBottom: 12 }}>
                      <MultiExpansionPanels
                        arr={[
                          {
                            title: 'EDITOR',
                            component: <Editor />,
                            color: 'green',
                            //customClassName: 'ignore-react-onclickoutside',
                            open: true,
                            toolTip: `Edit the selected section's content below.`,
                            noPadding: true,
                          },
                        ]}
                      />
                    </Grid>
                  ) : null}
                </Hidden>
                <Grid item xs={12} style={{ padding: 0 }}>
                  <General />
                </Grid>
                {emailCardSelected === 'blank' &&
                selectedActionPrediction === 'email' ? (
                  <Fragment>
                    <Grid item xs={12} style={{ padding: 0 }}>
                      <EmailForm />
                    </Grid>
                    <Grid item xs={12} style={{ padding: 0 }}>
                      <Variables />
                    </Grid>
                  </Fragment>
                ) : null}
              </Grid>
            </RSC>
          </Grid>
        </Hidden>
        <Hidden mdUp>
          <MobileForm modal={modal} style={{ bottom: '-25px' }} />
        </Hidden>
      </Grid>
      <Hidden lgUp>
        <EditorDialog />
      </Hidden>
    </main>
  )
}

export default connect(
	(state) => ({
		codeEditorDisplayed: state.email.codeEditorDisplayed,
		emailCardSelected: last(state.email.cardSelected),
		selectedActionPrediction:
			state.tasks.addOrEdit.fields.selectedActionPrediction.value,
		sectionSelectedBool:
			typeof state.email.sectionSelected === 'number' ||
			typeof state.email.sectionSelected === 'string',
	}),
	null,
)(withStyles(styles)(SplitForm))
